export default __webpack_public_path__ + "static/project-slide-5-4032-2268-c9b66029d43cfc98203a9a1db033138c.jpg";